import { render, staticRenderFns } from "./PageMaker.vue?vue&type=template&id=127b10f6&scoped=true&"
import script from "./PageMaker.vue?vue&type=script&lang=js&"
export * from "./PageMaker.vue?vue&type=script&lang=js&"
import style0 from "./PageMaker.vue?vue&type=style&index=0&id=127b10f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b10f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
